import { Component, Input } from '@angular/core';

@Component({
  selector: 'psc-annotations',
  templateUrl: './annotations.component.html',
})
export class AnnotationsComponent {
  @Input() taxIncluded: boolean = true;

  readonly annotationList: string[] = [
    'effectiveness',
    'accuracy'
  ];
}
